import { START_PAGE } from "../../utils/Constant";
import { GET_ALL_CONTENT } from "./ActionTypes";

export const getAllContent = (payload, currentPage = START_PAGE) => ({
  type: GET_ALL_CONTENT,
  payload,
  currentPage,
});